// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__1Y6ZS","close":"styles_close__3Zry8","input":"styles_input__2AauV","match":"styles_match__1i8hL","icon":"styles_icon__2VWIL"};